import * as z from "zod";
import { setTenantRoles } from "../rbac/validation/setTenantRoles";
import { mutator } from "./mutator";

export const setUserGroupTenantRoles = mutator({
  schema: z.object({
    userGroupId: z.string(),
    builtinRoleIds: z.array(z.string()).default([]),
    customRoleIds: z.array(z.string()).default([]),
  }),
  resolve: {
    userGroup: { kind: "userGroup", from: "userGroupId" },
  },
  permissions: [
    {
      permission: "user_group:write",
      scopeId: ({ args }) => args.userGroup.id,
    },
    { permission: "tenant:roles_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({
    tx,
    ctx,
    args: { userGroup, builtinRoleIds, customRoleIds },
  }) => {
    await setTenantRoles(
      tx,
      { userGroupId: userGroup.id },
      builtinRoleIds,
      customRoleIds,
      ctx.tenantId,
      ctx
    );
  },
});
